import { render, staticRenderFns } from "./Announce.vue?vue&type=template&id=72e56ea4&scoped=true&"
import script from "./Announce.vue?vue&type=script&lang=js&"
export * from "./Announce.vue?vue&type=script&lang=js&"
import style0 from "./Announce.vue?vue&type=style&index=0&id=72e56ea4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e56ea4",
  null
  
)

export default component.exports